<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p18" title="18">
<h2 class="recipetitle" id="the_ultimate_pancakes">The Ultimate Pancakes</h2>
<p class="recipetime"><span class="yield_black">7 servings (3 pancakes each)</span> <span class="separater">|</span> Prep Time: 30 Minutes <span class="separater">|</span> Start to Finish: 30 Minutes</p>
<p class="dot">•••</p>
<ul class="ingredient">
<li class="list"><span class="qty1">2</span> cups Original Bisquick™ mix</li>
<li class="list"><span class="qty1">3</span> tablespoons sugar</li>
<li class="list"><span class="qty1">2</span> teaspoons baking powder</li>
<li class="list"><span class="qty1">1</span> cup milk</li>
<li class="list"><span class="qty1">2</span> tablespoons vegetable oil</li>
<li class="list"><span class="qty1">2</span> eggs</li>
<li class="list"><span class="qty1">1</span> teaspoon vanilla, if desired</li>
</ul>
<p class="recipeprocedure"><span class="stepnum">1</span> Brush griddle or skillet with vegetable oil, or spray with cooking spray. Heat griddle to 350°F, or heat skillet over medium heat.</p>
<p class="recipeprocedure"><span class="stepnum">2</span> In medium bowl, stir all ingredients with whisk or fork until blended.</p>
<p class="recipeprocedure"><span class="stepnum">3</span> For each pancake, pour slightly less than ¼ cup batter onto hot griddle. Cook 2 to 3 minutes or until edges are dry. Turn; cook other side until golden brown.</p>
<p class="recipeprocedure"><span class="stepnum">4</span> To freeze, cool completely. Place pancakes in resealable freezer plastic bag; seal bag. Freeze up to 3 months.</p>
<p class="recipeprocedure"><span class="stepnum">5</span> To reheat, place 3 pancakes on microwavable plate. Microwave uncovered on High 1 minute or until hot.</p>
<p class="recipe_info"><span class="nutr_bold">1 Serving:</span> Calories 230; Total Fat 10g (Saturated Fat 3g, Trans Fat 1.5g); Cholesterol 65mg; Sodium 590mg; Total Carbohydrate 30g (Dietary Fiber 1g); Protein 5g <span class="nutr_bold">Exchanges:</span> 1½ Starch, ½ Other Carbohydrate, 2 Fat <span class="nutr_bold">Carbohydrate Choices:</span> 2</p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p018.vue?38a1bebc